import React from 'utils/react';
import withTranslation from 'utils/react/withTranslation';
import CreatableSelect from './CreatableSelect';
import Container from './Container';
import Label from './Label';

class InputSelectTags extends React.PureComponent {
  handleChange = (value) => {
    this.props.onChange(this.props.name, value);
  };

  handleBlur = () => {
    this.props.onBlur(this.props.name, true);
  };

  render() {
    const { name, options, value, label } = this.props;
    return (
      <Container>
        <Label>{label}</Label>
        <CreatableSelect
          name={name}
          options={options}
          isMulti
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          value={value}
          placeholder=''
        />
      </Container>
    );
  }
}

export default withTranslation()(InputSelectTags);
